import { createContext, useCallback, useContext, useEffect, useState } from 'react';
import { adminGetMe, adminLogin as apiLogin } from '../services/adminApiClient';

const AdminAuthContext = createContext(null);

export const AdminAuthProvider = ({ children }) => {
  const [admin, setAdmin] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const token = localStorage.getItem('pillpoint_admin_token');
    if (token) {
      adminGetMe()
        .then((res) => setAdmin(res.data))
        .catch(() => localStorage.removeItem('pillpoint_admin_token'))
        .finally(() => setLoading(false));
    } else {
      setLoading(false);
    }
  }, []);

  const login = useCallback(async (email, password) => {
    const res = await apiLogin(email, password);
    localStorage.setItem('pillpoint_admin_token', res.token);
    setAdmin(res.data);
    return res;
  }, []);

  const logout = useCallback(() => {
    localStorage.removeItem('pillpoint_admin_token');
    setAdmin(null);
  }, []);

  return (
    <AdminAuthContext.Provider value={{ admin, loading, login, logout }}>
      {children}
    </AdminAuthContext.Provider>
  );
};

export const useAdminAuth = () => useContext(AdminAuthContext);
